import { Box, Button, Modal, Stack, Typography } from "@mui/material"
import { SaveStyle } from "./modalBoxStyle"
import { useCrudForm } from "../../api/useCrudForm";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import { toast } from "react-toastify";

export const ActivateDeactivateAlertModal = ({ message, customEndpoint, endpoint, selectedId, openAlertModal, setOpenAlertModal, onSuccess, onError }: { message?: any, customEndpoint?: boolean, selectedId: number, onSuccess: () => void, onError: () => void, endpoint: string, setOpenAlertModal: React.Dispatch<React.SetStateAction<boolean>>, openAlertModal: boolean }) => {

    const { add } = useCrudForm()

    const onSubmitAction = (id: number) => {
        if (id) {
            add({
                endpoints: customEndpoint ? endpoint : `${endpoint}/${id}`,
                onSuccess: (data: any) => {
                    onSuccess()
                    toast.success(data.message, { style: { background: '#3150A1' } })
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    onError()
                },
                values: ''
            })
        }
    }

    return <Modal
        open={openAlertModal}
        onClose={onError}
    >
        <Box sx={{ ...SaveStyle, width: 200, textAlign: 'center' }}>
            <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                <NotificationImportantIcon sx={{ width: '60px', height: '60px', color: 'red' }} />
                <Typography sx={{ margin: '0 0px 10px', padding: '0px' }}>{message ? message : 'Are you sure want to deactivate?'}</Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Button onClick={() => onSubmitAction(selectedId)} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '50%' }}>Confirm</Button>
                    <Button onClick={() => onError()} variant='contained' sx={{ backgroundColor: 'red', color: 'white', width: '50%' }} color="error" > Cancel</Button>
                </Box>
            </Stack>
        </Box >
    </Modal >
}